































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { formatPrice } from "../../utils/general-functions";
import UpdateLicenseDialog from "../admin/UpdateLicenseDialog.vue";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component({
  components: {
    UpdateLicenseDialog
  }
})
export default class SingleProduct extends Vue {
  @Prop() license!: any;
  @Prop() licenses!: any;
  @Prop() page!: number;

  dialogDelete = false;
  loadingDelete = false;
  dialogUpdate = false;
  componentKey = 1;
  currentLicense = null;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private created(): void {
    this.currentLicense = this.license;
  }

  private removeLicense(): void {
    this.loadingDelete = true;
    this.$store
      .dispatch("product/deleteLicenseToProduct", {
        licenseID: this.license.licenseID,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE
      })
      .then(() => {
        this.loadingDelete = false;
      });
  }

  private formatPrice(value: any): string {
    return formatPrice(value);
  }

  private openDialogUpdate(): void {
    this.dialogUpdate = true;
    this.componentKey++;
  }

  private openSuccessSnackbar(): void {
    this.$emit("openSuccessSnackbar");
  }

  private openErrorSnackbar(): void {
    this.$emit("openErrorSnackbar");
  }
}
